import CloseIcon from '@mui/icons-material/Close';
import {
  DialogTitle,
  Typography,
  IconButton,
  DialogContent,
  Box,
  Grid,
  TextField,
  DialogActions,
} from '@mui/material';
import { useState } from 'react';
import { IPrompt } from 'wisestep-api';
import { WsDialog, WsDialogSize, WsButton } from 'wisestep-base';

import { warning } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';

export interface IPromptDialog {
  openPromptDialog: boolean;
  promptData: IPrompt[];
  selectedPrompt: IPrompt;
  handleOpenPromptDialogForEdit: (value: boolean) => void;
  onSetPromptdata: (value: IPrompt[]) => void;
}

const PromptDialogForEdit = ({
  openPromptDialog,
  promptData,
  selectedPrompt,
  handleOpenPromptDialogForEdit,
  onSetPromptdata,
}: IPromptDialog) => {
  const [editPromptTitle, setEditPromptTitle] = useState(selectedPrompt.promptTitle);
  const [editPromptDescription, setEditPromptDescription] = useState(selectedPrompt.prompt);

  const handleInputChangeOnEditPromptTitle = (event) => setEditPromptTitle(event.target.value);
  const handleInputChangeOnEditPrompt = (event) => setEditPromptDescription(event.target.value);
  const setNotification = useNotificationStore((state) => state.setNotification);
  const onEditPrompt = () => {
    if (editPromptTitle.trim().length == 0) {
      setNotification(warning('Please fill the prompt title'));
    } else if (editPromptDescription.trim().length == 0) {
      setNotification(warning('Please fill the prompt'));
    } else {
      onSetPromptdata(
        promptData.map((data) =>
          data.id === selectedPrompt.id
            ? { ...data, promptTitle: editPromptTitle, prompt: editPromptDescription }
            : data
        )
      );
      handleOpenPromptDialogForEdit(false);
    }
  };

  return (
    <WsDialog openDialog={openPromptDialog} size={WsDialogSize.MEDIUM}>
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant="h6" align="left">
          Edit Prompt
          <span style={{ color: 'rgba(0, 0, 0, 0.54)' }}> - {promptData[0].scope}</span>
        </Typography>
        <Typography variant="h6" align="left">
          <IconButton
            onClick={() => handleOpenPromptDialogForEdit(false)}
            size="small"
            sx={{
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'transparent',
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Typography>
      </DialogTitle>
      <DialogContent
        sx={{
          backgroundColor: '#EAEAF1',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box>
          <Grid
            container
            spacing={1}
            sx={{
              backgroundColor: 'white',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginTop: 2.5,
            }}
          >
            <Grid item xs={12} sx={{ marginLeft: 2.5 }}>
              <Typography variant="h6" align="left">
                Prompt Title *
              </Typography>
            </Grid>
            <Grid item xs={12} sx={{ marginLeft: 2.5 }}>
              <TextField
                required={true}
                size="small"
                sx={{
                  width: '80%',
                }}
                value={editPromptTitle}
                placeholder="Enter title"
                onChange={handleInputChangeOnEditPromptTitle}
              />
            </Grid>
            <Grid item xs={12} sx={{ marginLeft: 2.5 }}>
              <Typography variant="h6" align="left">
                Prompt *
              </Typography>
            </Grid>
            <Grid item xs={12} sx={{ marginLeft: 2.5 }}>
              <TextField
                size="small"
                sx={{
                  width: '95%',
                  marginRight: 1.2,
                  marginBottom: 2.5,
                }}
                required={true}
                value={editPromptDescription}
                placeholder="Write prompt to ChatGPT"
                onChange={handleInputChangeOnEditPrompt}
                multiline
                rows={6}
              />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions
        sx={{
          alignItems: 'center',
          padding: 2,
        }}
      >
        <Box textAlign="right" sx={{ marginRight: '15px' }}>
          <WsButton
            size="large"
            variant="contained"
            onClick={() => {
              onEditPrompt();
            }}
          >
            save
          </WsButton>
        </Box>
      </DialogActions>
    </WsDialog>
  );
};
export default PromptDialogForEdit;
